import { useExplat } from './useExplat';
import { baseEligibilityCheck } from './utils';

const EXPERIMENT_NAME = 'new_iframe_vendors';

export function useVendorsIframe(
  { skipLogging = false, useAnonymousID = true } = {
    skipLogging: false,
    useAnonymousID: true,
  }
) {
  const isEligible = baseEligibilityCheck();
  const { variant, isLoaded } = useExplat(EXPERIMENT_NAME, {
    isEligible,
    skipLogging,
    useAnonymousID,
  });

  return {
    isLoaded,
    isControl: variant === 'control' || !variant,
    isVariant: variant === 'variant',
  };
}
